<app-header-style-two></app-header-style-two>

<div class="page-title-area">
    <div class="container">
        <h1>Driving Lesson Packages – Staten Island, NY</h1>
    </div>
</div>

<!-- Loading Animation -->
<div class="loading-container" *ngIf="!isLoading">
    <div class="loading-spinner">
        <div class="spinner"></div>
        <p>Loading amazing packages...</p>
    </div>
</div>

<!-- Main Content Area -->
<div class="main-content-area" *ngIf="isLoading">
    <div class="container">
        <div class="packages-grid">
            <div class="package-card" *ngFor="let item of models">
                <!-- <div class="card-header">
                    <div class="package-badge">
                        <i class="bx bx-star"></i>
                        Premium Package
                    </div>
                    <div class="package-icon">
                        <i class="bx bx-package"></i>
                    </div>
                </div> -->
                
                <div class="card-body">
                    <h3 class="package-title">{{item?.name}}</h3>
                    
                    <div class="price-section">
                        <div class="current-price">
                            <span class="currency">$</span>
                            <span class="amount">{{ item.price }}</span>
                        </div>
                        <div class="original-price" *ngIf="item.priceBeforeDiscount">
                            <span class="currency">$</span>
                            <span class="amount">{{ item.priceBeforeDiscount }}</span>
                        </div>
                        <div class="savings" *ngIf="item.priceBeforeDiscount">
                            <span class="savings-text">Save ${{ item.priceBeforeDiscount - item.price }}</span>
                        </div>
                    </div>
                    
                    <div class="package-description" [innerHTML]="item.details"></div>
                    
                    <div class="package-features">
                        <div class="feature-item">
                            <i class="bx bx-check-circle"></i>
                            <span>Comprehensive Training</span>
                        </div>
                        <div class="feature-item">
                            <i class="bx bx-check-circle"></i>
                            <span>Flexible Schedule</span>
                        </div>
                        <div class="feature-item">
                            <i class="bx bx-check-circle"></i>
                            <span>Expert Instructors</span>
                        </div>
                        <div class="feature-item">
                            <i class="bx bx-check-circle"></i>
                            <span>Practice Tests</span>
                        </div>
                    </div>
                </div>
                
                <div class="card-footer">
                    <button 
                        class="select-package-btn" 
                        (click)="selectPackage(item.referenceId)"
                        [disabled]="savingItemId === item.referenceId"
                    >
                        <span *ngIf="savingItemId !== item.referenceId">
                            <i class="bx bx-shopping-cart"></i>
                            Choose Package
                        </span>
                        <span *ngIf="savingItemId === item.referenceId" class="loading-text">
                            <i class="bx bx-loader-alt bx-spin"></i>
                            Processing...
                        </span>
                    </button>
                </div>
            </div>
        </div>
        
        <!-- Contact Section -->
        <div class="contact-section">
            <div class="contact-card">
                <div class="card-header">
                    <h3 class="card-title">
                        <i class="bx bx-phone"></i>
                        Need Help Choosing?
                    </h3>
                </div>
                <div class="contact-content">
                    <p>Our team is here to help you choose the perfect package for your needs.</p>
                    <div class="contact-methods">
                        <div class="contact-method" style="background-color: rgb(60, 56, 113)">
                            <a [href]="'tel:' + phone">
                                <i class="bx bx-phone"></i>
                                <span style="color: white!important;">Call us anytime: {{phone}}</span>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>